export const blueCardOpportunityColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq:longr1_id',
  'account_number',
  'health_system_id',
  'facility_id',
  'facility_name',
  'opportunity_type',
  'solution',
  'solution_id',
  'status',
  'status_id',
  'created_date',
  'last_modified_date',
  'created_by',
  'modified_by',
  'is_manually_created',
  'is_sync_needed',
  'rule_detail_id',
  'rule_detail_version',
  'rule_detail_rule_name',
  'rule_assigned_category_name',
  'rule_assigned_classification_name',
  'rule_assigned_root_cause_name',
  'rule_assigned_due_date_basis_type',
  'rule_assigned_due_date',
  'rule_efficiency',
  'rule_complexity_score',
  'efficiency_score:',
  'pricing_xr_id',
  'opportunity_value:',
  'log',
  'day',
];
